@if (!item()!.hidden) {
 
  <ng-container *aclFeatures="item().section">

  <li
    data-username="able-pro dashboard"
    class="nav-item coded-hasmenu"
    [routerLinkActive]="['active']"
    [ngClass]="{ disabled: !isEnabled }"
    matTooltip="{{ !isEnabled ? 'Logout and Login with Admin to view this page ' : '' }}"
  >
    <a [routerLinkActive]="['active']" class="nav-link" (click)="navCollapse($event)">
      @if (item()!.icon) {
        <span class="coded-micon">
          <svg class="pc-icon">
            <use attr.xlink:href="assets/fonts/custom-icon.svg{{ item()!.icon }}"></use>
          </svg>
        </span>
      }
      <span class="coded-mtext">{{ item()!.title | translate }}</span>
    </a>
    <ul class="coded-submenu" [routerLinkActive]="['active']" [ngClass]="item()!.classes!">
      @for (items of item()!.children; track $index) {
        <ng-container *aclFeatures="item().section">

        @if (items.type === 'item') {
          <app-menu-item-compact [item]="items" [parentRole]="item()!.role && item()!.role!.length > 0 ? item()!.role : parentRole.role" />
        } @else if (items.type === 'collapse') {
          <app-menu-collapse-compact
            [item]="items"
            [parentRole]="item()!.role && item()!.role!.length > 0 ? item()!.role : parentRole.role"
          />
        }
        </ng-container>
      }
    </ul>
  </li>
  </ng-container>
}
